import {findIndex} from 'lodash';
import * as categoryActionTypes from './therapeuticCategoryActionTypes';
import * as areaActionTypes from '../therapeuticArea/therapeuticAreaActionTypes';

const categoryInitialState = {
  categoryList: []
};

const therapeuticCategoryReducer = (state = categoryInitialState, action) => {
  switch (action.type) {
    case categoryActionTypes.SET_CATEGORY_LIST:
      return {
        ...state,
        categoryList: [
          ...state.categoryList,
          ...action.categoryList
        ]
      };

    case categoryActionTypes.ADD_CATEGORY:
      return {
        ...state,
        categoryList: [
          ...state.categoryList,
          ...[action.category]
        ]
      };

    case categoryActionTypes.UPDATE_CATEGORY:
      {
        const {category} = action;
        return {
          ...state,
          categoryList: state
            .categoryList
            .map((p) => {
              if (p.id === category.id) 
                return category;
              return p;
            })
        };
      }

    case categoryActionTypes.DELETE_CATEGORY:
      {
        const {categoryId} = action;
        const categoryIndex = findIndex(state.categoryList, (category) => category.id === categoryId);
        return {
          ...state,
          categoryList: [
            ...state
              .categoryList
              .slice(0, categoryIndex),
            ...state
              .categoryList
              .slice(categoryIndex + 1)
          ]
        };
      }

    case areaActionTypes.ADD_AREA:
      {
        const {area} = action;
        return {
          ...state,
          categoryList: state
            .categoryList
            .map((category) => {
              if (category.id === area.category) {
                return {
                  ...category,
                  therapeuticAreas: [
                    ...category.therapeuticAreas,
                    ...[
                      {
                        id: area.id,
                        name: area.name
                      }
                    ]
                  ]
                };
              }
              return category;
            })
        };
      }

    case areaActionTypes.DELETE_AREA:
      {
        const {categoryId, areaId} = action;
        const categoryIndex = findIndex(state.categoryList, category => category.id = categoryId);
        let areaIndex = -1;
        if (categoryIndex > -1) {
          areaIndex = findIndex(state.categoryList[categoryIndex].therapeuticAreas, area => area.id = areaId);
        }
        if (areaIndex > -1) {
          return {
            ...state,
            categoryList: state
              .categoryList
              .map((category) => {
                if (category.id === categoryId) {
                  return {
                    ...category,
                    therapeuticAreas: [
                      ...category
                        .therapeuticAreas
                        .splice(0, areaIndex),
                      ...category
                        .therapeuticAreas
                        .splice(areaIndex + 1)
                    ]
                  };
                }
                return category;
              })
          };
        } else {
          return state;
        }
      }

    default:
      return state;
  }
};

export default therapeuticCategoryReducer;



// WEBPACK FOOTER //
// ./src/therapeuticCategory/therapeuticCategoryReducer.js